import { Enum } from './Enum';

export class EstablishedVisitStatus extends Enum {
  translationKey = 'establishedVisitStatus';

  static asArray: EstablishedVisitStatus[] = [];

  static byKey: { [name: string]: EstablishedVisitStatus } = {};

  static readonly RECONSENT_COMPLEX = new EstablishedVisitStatus(
    'RECONSENT_COMPLEX',
  );

  static readonly COMPLEX_ONLY = new EstablishedVisitStatus('COMPLEX_ONLY');

  static readonly RECONSENT_ONLY = new EstablishedVisitStatus('RECONSENT_ONLY');

  static toSelectable() {
    return Enum.toSelectable(EstablishedVisitStatus.asArray);
  }

  constructor(public readonly value: string) {
    super();
    EstablishedVisitStatus.asArray.push(this);
    EstablishedVisitStatus.byKey[value] = this;
  }
}

export default EstablishedVisitStatus;
